<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <!-- <div class="col-sm-6">
            <h1>Bill Payment</h1>
          </div> -->
          <div class="col-sm-6">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">Billing Payment</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-8">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Payment Information</h3>
              </div>
              <form @submit.prevent="RequestPayment" method="POST" novalidate>
                <!-- <input
                  type="hidden"
                  id="cardType"
                  name="cardType"
                  v-model="paymentModel.cardType"
                /> -->
                <input
                  type="hidden"
                  id="cuid"
                  name="cuid"
                  v-model="paymentModel.cuid"
                />
                <input
                  type="hidden"
                  id="city"
                  name="city"
                  v-model="paymentModel.city"
                />
                <div class="card-body">
                  <div class="form-row">
                    <div class="col-md-12">
                      <div class="form-row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="col-form-label" for="amount"
                              >Amount</label
                            >
                            <input
                              type="number"
                              class="form-control"
                              id="amount"
                              v-model="paymentModel.amount"
                              placeholder="Amount"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="col-form-label" for="name"
                              >Full Name</label
                            >
                            <input
                              type="text"
                              class="form-control"
                              id="name"
                              v-model="paymentModel.name"
                              placeholder="Name"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="col-form-label" for="email"
                              >Email</label
                            >
                            <input
                              type="text"
                              class="form-control"
                              id="email"
                              v-model="paymentModel.email"
                              placeholder="Email"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="col-form-label" for="phone"
                              >Phone</label
                            >
                            <input
                              type="text"
                              class="form-control"
                              id="phone"
                              v-model="paymentModel.phone"
                              placeholder="Phone"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-form-label" for="address"
                          >Address</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id="address"
                          v-model="paymentModel.address"
                          placeholder="Address"
                        />
                      </div>
                      <div class="form-group">
                        <label class="col-form-label" for="description"
                          >Description</label
                        >
                        <textarea
                          name=""
                          v-model="paymentModel.description"
                          class="form-control"
                          id="description"
                          placeholder="Write your message"
                          cols="20"
                          rows="3"
                        ></textarea>
                      </div>

                      <div class="form-group form-row">
                        <div class="form-check">
                          <label class="form-check-label" for="term">
                            <input
                              @change="isTermChecked($event)"
                              v-model="paymentModel.term"
                              type="checkbox"
                              class="form-check-input"
                              id="term"
                            />
                            I agree to the
                            <a
                              @click.prevent="visitLink($event)"
                              target="_blank"
                              :href="helpBaseUrl + '/knowledge/legal/terms-and-conditions'"
                            >
                              terms &#38; conditions,</a
                            >
                            <a
                              target="_blank"
                              :href="helpBaseUrl + '/knowledge/legal/privacy-policy'"
                            >
                              privacy policy,</a
                            >
                            <a
                              target="_blank"
                              :href="helpBaseUrl + '/knowledge/legal/return-refund-policy'"
                            >
                              refund &#38; return policy</a
                            >
                          </label>
                          <span
                            class="invalid-feedback d-inline-block"
                            v-show="vErrors"
                            >{{ vErrors[0] }}</span
                          >
                        </div>
                      </div>
                      <button type="submit" class="btn btn-dark-blue btn-block">
                        Pay now
                      </button>
                    </div>
                  </div>
                </div>
              </form>

              <div class="overlay" v-if="is_loading">
                <i class="fas fa-2x fa-sync-alt fa-spin"></i>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Billing Highlight</h3>
              </div>
              <div class="card-body paybill-body">
                <ul>
                  <li>
                    My Package: <span>{{ value.package }}</span>
                  </li>
                  <li>
                    Monthly Bill: <span>{{ value.monthlyAmount }}</span>
                  </li>
                  <li>
                    Available Balance: <span>{{ value.availableBalance }}</span>
                  </li>
                  <li>
                    Bill due date: <span>{{ value.billDueDate }}</span>
                  </li>
                  <li>
                    Total bill <span>{{ value.monthlyAmount }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
// import { CommonAPI } from "@/services/api";
import { Notification } from "element-ui";
const fileDownload = require("js-file-download");
import { Cordova } from "@awesome-cordova-plugins/core";
import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser/ngx";
import { Capacitor } from "@capacitor/core";

export default {
  name: "BillPayment",
  metaInfo: {
    title: "Bill Payment | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },

  data: () => ({
    vErrors: [],
    value: {
      // package: '10MB',
      // monthlyAmount: '2000TK',
      // availableBalance: '3000TK',
      // billDueDate: '10/02/2022'
    },

    paymentModel: {
      cuid: "",
      amount: 0,
      phone: "0190213",
      name: "",
      email: "",
      city: "",
      address: "",
      description: "",
    },

    list: {
      total: 0,
      per_page: 3,
      from: 1,
      to: 0,
    },
    order_by: "asc",
    api_url: "",
    showFilter: false,
    helpBaseUrl: process.env.VUE_APP_HELP_BASE_URL || '',
    filter: {},
    dateRange: "",
    pre: [],
    is_loading: false,
    has_permission: true,
    cardType: "",
  }),
  // method is called after page load
  mounted: function () {
    // if (this.isMobile()) {
    //   window.$(document).find('.push-menu-class').trigger('click')
    // }

    console.log("Route Params::", this.$route.params);
    let routeParams = this.$route.params;
    this.cardType = routeParams.paymentType || "";
    this.getPackageInfo();
    this.getMyAccountDetails();
  },
  methods: {
    isTermChecked: function (event) {
      if (this.paymentModel.term) {
        this.vErrors = [];
      }
    },

    getPackageInfo: function () {
      let api_url = "/get-bill-info";
      let _this = this;
      _this.is_loading = true;
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      console.log("Subscriber::", subscriber);
      if (subscriber) {
        axios
          .get(api_url, { params: { cuid: subscriber.username } })
          .then((response) => {
            //console.log('response.data::', response.data);
            response.data.monthlyAmount =
              "£ " +
              parseFloat(response.data.monthlyAmount).toLocaleString("en-US", {
                maximumFractionDigits: 2,
              });
            response.data.billDueDate = moment(
              response.data.billDueDate
            ).format("DD/MM/YYYY");
            response.data.availableBalance =
              "£ " +
              parseFloat(response.data.availableBalance).toLocaleString(
                "en-US",
                {
                  maximumFractionDigits: 2,
                }
              );
            _this.value = response.data;

            // _this.value = response.data;
            _this.is_loading = false;
          })
          .catch((error) => {
            console.log("error " + error);
            _this.is_loading = false;
          });
      }
    },

    getMyAccountDetails() {
      let api_url = "/get-account-info";
      let _this = this;
      _this.is_loading = true;
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      console.log("Subscriber::", subscriber);
      if (subscriber) {
        axios
          .get(api_url, { params: { cuid: subscriber.username } })
          .then((response) => {
            //console.log('response.data::', response.data);
            _this.paymentModel = response.data;
            _this.paymentModel.name = response.data.username;
            _this.paymentModel.city = response.data.city;
            // _this.value = response.data;
            _this.is_loading = false;
          })
          .catch((error) => {
            console.log("error " + error);
            _this.is_loading = false;
          });
      }
    },

    visitLink($event) {
      console.log("::::::href:::", $event.target.href);
      const redirectUrl = $event.target.href;
      // console.log("Redirect URL::", redirectUrl);
      if (!Capacitor.isNativePlatform()) {
        // alert("Non Native Platform");
        // return;
        window.location.href = redirectUrl;
      } else {
        // @ts-ignore
        let ref = cordova.InAppBrowser.open(
          redirectUrl,
          "_blank",
          "location=yes,hideurlbar=yes"
        );
      }
    },

    RequestPayment() {
      const _this = this;
      // window.open('https://demo-cashier.dotlines.com.bd/short/redirect.php?payment_id=Centc418833.68616149-19072-KfiNH', '_self');
      // window.url
      this.paymentModel.cardType = this.cardType;
      // console.log(this.paymentModel);
      // alert("Are you sure?");
      // return;
      if (!this.paymentModel.term) {
        _this.vErrors.push(
          "Please, Check terms and conditions before generating payment request."
        );
        return;
      }
      _this.$validator.validateAll().then((result) => {
        //console.log("Result::", result)
        if (result) {
          _this.is_loading = true;
          const api_url = "/request-payment";
          const method = "POST";
          // let subscriber = localStorage.getItem("subscriber");
          // subscriber = JSON.parse(subscriber);
          // // console.log("Subscriber::", subscriber);
          // _this.paymentModel.cuid = subscriber.cuid;
          console.log("Payload::", _this.paymentModel);
          axios({
            method: method,
            url: api_url,
            data: _this.paymentModel,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              console.log(response.data);
              const responseData = response.data;
              if (
                responseData &&
                (responseData.code === "200" || responseData.code === 200)
              ) {
                var paymentId = responseData.data.payment_id;
                paymentId = encodeURIComponent(paymentId);
                const redirectUrl =
                  responseData.data.redirect_url + "?payment_id=" + paymentId;

                console.log("Redirect URL::", redirectUrl);
                if (!Capacitor.isNativePlatform()) {
                  // alert("Non Native Platform");
                  // return;
                  window.location.href = redirectUrl;
                } else {
                  // @ts-ignore
                  let ref = cordova.InAppBrowser.open(
                    redirectUrl,
                    "_blank",
                    "location=yes,hideurlbar=yes"
                  );

                  let myCallback = function (event) {
                    console.log("Updated URL: ", event.url);
                    // alert("Updated URL:" + event.url);
                    // separate host form url
                    // let host = event.url.split('/')[2];
                    // get all query params
                    let queryParams = event.url.split("?")[1];
                    if (event.url.includes("paymentResult?tnxStatus=")) {
                      console.log("InAppBrowser closed");
                      ref.close();
                      setTimeout(() => {
                        _this.$router.push("paymentResult?" + queryParams);
                      }, 500);
                    }
                  };
                  ref.addEventListener("loadstart", myCallback);
                }

                // window.open(redirectUrl, '_self')
              } else {
                _this.$toaster.success(responseData.message);
              }
              // alert('Success')
              // _this.$toaster.success(response.data.message)
              _this.is_loading = false;
              // _this.$router.push({ name: "Users" });
            })
            .catch((errors) => {
              _this.$setErrorsFromResponse(errors.response.data);
            })
            .finally(() => {
              _this.is_loading = false;
            });
        } else {
          //console.log('Validation failed')
        }
      });
    },

    OpenTicket() {
      const _this = this;
      _this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          const api_url = "/open-ticket";
          const method = "POST";
          console.log(this.ticket);
          axios({
            method: method,
            url: api_url,
            data: _this.ticket,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.is_loading = false;
              // _this.$router.push({ name: "Users" });
            })
            .catch((errors) => {
              _this.$setErrorsFromResponse(errors.response.data);
            })
            .finally(() => {
              _this.is_loading = false;
            });
        } else {
          console.log("Validation failed");
        }
      });
    },

    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD hh:mm:ss");
    },

    apiUsage(query = null) {
      return new Promise((resolve, reject) => {
        axios
          .get(this.api_url, {
            params: query,
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            if (error.response.status === 403) {
              this.has_permission = false;
            }
            reject(error);
          });
      });
    },
  },
};
</script>
